export const LOCATION_TYPES = {
  COUNTRY: 'COUNTRY',
  STATE: 'STATE',
  CITY: 'CITY',
  DISTRICT: 'DISTRICT',
  NEIGHBORHOOD: 'NEIGHBORHOOD',
}

//maximum number of characters for the text fields
export const MAX_CHAR_LIMIT = {
  NAME: 50,
  REVIEW: 500,
  DESCRIPTION: 250,
  LINK: 250,
  FIELD_LENGTH_TOOLTIP_NAME: 288,
}

export const LOCATION_NOTFOUND_MESSAGE = 'Not defined (see the map)'
